import { ERROR, FLUSH, MESSAGE, POST_DETAILS, POST_LIST, POST_COMMENTS, POST_LIKES } from './constants';

const initialState = {
  error: null,
  list: [],
  message: null,
  details: {
    comments: [],
    likes: []
  }
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    
    case ERROR:
      return {
        ...state,
        error: action.error
      };

    case POST_LIST:
      return {
        ...state,
        list: action.result
      };

    case FLUSH:
      return {
        ...initialState
      };

    case MESSAGE:
      return {
        ...state,
        message: action.message
      };

    case POST_DETAILS:
      return {
        ...state,
        details: action.result
      };

    case POST_COMMENTS:
      return {
        ...state,
        details: Object.assign({}, state.details, {
          comments: action.result
        })
      };

    case POST_LIKES:
      return {
        ...state,
        details: Object.assign({}, state.details, {
          likes: action.result
        })
      };

    default: 
      return {
        ...state
      }
  }
}
